(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpf-build-box-zip-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = "[data-tpf-build-box]";
    const stateKey = "tpf_delivery_zip";
    const template = document.getElementById("TpfBuildBoxZipGateTemplate");

    if (!template) return;

    const readStoredState = () => {
      try {
        const state = JSON.parse(localStorage.getItem(stateKey) || "null");
        return state && state.version === 1 ? state : null;
      } catch {
        return null;
      }
    };

    const getState = () => {
      return window.TPFCatalogEligibility?.getState?.() || readStoredState();
    };

    const getStatus = (state) => {
      if (state?.eligibility === "local") return "local";
      if (state?.eligibility === "out_of_area") return "unavailable";
      return "unknown";
    };

    const openZipChecker = () => {
      if (window.TPFCatalogEligibility?.openGate) {
        window.TPFCatalogEligibility.openGate();
        return;
      }

      if (window.ZipDelivery?.openChecker) {
        window.ZipDelivery.openChecker("zip-check");
        return;
      }

      document.querySelector("a[href=\"#zip-check\"]")?.click();
    };

    const renderRoot = (root, state) => {
      const shell = root.querySelector("[data-tpf-bab-shell]");
      const gate = root.querySelector("[data-tpf-bab-zip-gate]");
      const unknown = gate?.querySelector("[data-tpf-bab-zip-unknown]");
      const unavailable = gate?.querySelector("[data-tpf-bab-zip-unavailable]");
      const status = getStatus(state);

      if (!shell || !gate || !unknown || !unavailable) return;

      root.dataset.tpfBabZipStatus = status;
      shell.hidden = status !== "local";
      shell.inert = status !== "local";
      gate.hidden = status === "local";
      unknown.hidden = status !== "unknown";
      unavailable.hidden = status !== "unavailable";

      gate.querySelectorAll("[data-tpf-bab-current-zip]").forEach((element) => {
        element.textContent = state?.zip || "";
      });
    };

    const initializeRoot = (root) => {
      if (root.dataset.tpfBabZipGateReady === "true") return;

      const shell = root.querySelector("[data-tpf-bab-shell]");
      if (!shell) return;

      const gate = template.content.firstElementChild.cloneNode(true);
      shell.before(gate);
      root.dataset.tpfBabZipGateReady = "true";

      gate.querySelectorAll("[data-tpf-bab-open-zip]").forEach((button) => {
        button.addEventListener("click", openZipChecker);
      });

      renderRoot(root, getState());
    };

    const initialize = (scope = document) => {
      if (scope.matches?.(rootSelector)) initializeRoot(scope);
      scope.querySelectorAll?.(rootSelector).forEach(initializeRoot);
    };

    const renderAll = (state = getState()) => {
      document.querySelectorAll(rootSelector).forEach((root) => renderRoot(root, state));
    };

    const boot = () => {
      initialize();
      renderAll();

      const designMode = document.documentElement.classList.contains("shopify-design-mode");
      if (!designMode && getStatus(getState()) === "unknown") {
        window.setTimeout(openZipChecker, 350);
      }
    };

    window.addEventListener("tpf:zip-changed", (event) => {
      renderAll(event.detail);
    });

    window.addEventListener("zipdelivery:updated", () => {
      window.requestAnimationFrame(() => renderAll());
    });

    window.addEventListener("storage", (event) => {
      if (event.key === stateKey) renderAll();
    });

    document.addEventListener("shopify:section:load", (event) => {
      initialize(event.target);
      renderAll();
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
